import { memo } from "react";
import { useSnackbarStore } from "./snackbar.store";
import { SnackbarItem } from "./snackbar-item";

export const SnackbarList = memo(() => {
	const messages = useSnackbarStore((s) => s.messages);

	return (
		<div className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-max max-w-[calc(100%-2rem)] -translate-x-1/2 flex-col items-center gap-2">
			{messages.map((m) => (
				<SnackbarItem key={m.id} {...m} />
			))}
		</div>
	);
});
SnackbarList.displayName = "SnackbarList";
